import QRCode from 'qrcode'
import CryptoJS from 'crypto-js'

import {aeskey} from './aeskey.js'
// 格式化时间
export function dateFormat(date) { return _formatDate(date) }
// 时间戳格式化
export function timestampFormat(date, fmt) { return _timestampFormat(date, fmt) }
// 设置cookie
export function setCookie(key, value, t) { return _setCookie(key, value, t) }
// 获取cookie
export function getCookie(key) { return _getCookie(key) }
// 删除cookie
export function removeCookie(key) { return _removeCookie(key) }
// 获取查询参数
export function getQueryParams(key) { return _getQueryParams(key) }
// 格式化后台list转object（内容管理）
export function formatCheckView(data, olderData) { return _formatCheckView(data, olderData) }
// 格式化object转后台list（内容管理）
export function formatCheckList(data) { return _formatCheckList(data) }
// 格式化fileInfo（内容管理）
export function formatFileInfo(data) { return _formatFileInfo(data) }
// 数字四舍五入
export function numberRound(num, length) { return _numberRound(num, length) }
// 计算文件B/KB/M/G
export function computeFileSize(size) { return _computeFileSize(size) }
// url转二维码转base64
export function urlToQRCode(url) { return _urlToQRCode(url) }
// url转二维码转base64（含logo）
export function promiseUrlToQRCode(url, logoUrl) { return _promiseUrlToQRCode(url, logoUrl) }
// 将base64转换为文件
export function data64toFile(dataurl, filename) { return _data64toFile(dataurl, filename) }
// 将base64转换为文件
export function downloadImage(imgsrc, name) { return _downloadImage(imgsrc, name) }
// 将文件转换为base64
export function filetoData64(params) { return _filetoData64(params) }
export function datetime_fine_parse(time) { return _datetime_fine_parse(time) }
// 获取url的参数
export function getAssignKeyLocationSearch(key, value) { return _getAssignKeyLocationSearch(key, value) }
// 把大于一万的数转成以万为单位的数
export function changeTenThousand(number) { return _changeTenThousand(number) }
export function examineMobilePhoneType() { return _examineMobilePhoneType() }
// aes解密
export function decode(data) { return _decode(data, aeskey) }
function _formatDate(date) {
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var day = date.getDate()
    var hours = date.getHours()
    var minutes = date.getMinutes()
    var seconds = date.getSeconds()

    month = month < 10 ? '0' + month : month
    day = day < 10 ? '0' + day : day
    hours = hours < 10 ? '0' + hours : hours
    minutes = minutes < 10 ? '0' + minutes : minutes
    seconds = seconds < 10 ? '0' + seconds : seconds

    var str = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
    return str
}
function _setCookie(key, value, t) {
    let oDate = new Date()
    oDate.setDate(oDate.getDate() + t)
    document.cookie = key + '=' + value + ';expires=' + oDate.toGMTString()
        + ';path=/'
        + ';domain=' + window.location.hostname.split('.').slice(-2).join('.');
}
function _getCookie(key) {
    var arr1 = document.cookie.split('; ')
    for (var i = 0; i < arr1.length; i++) {
        var arr2 = arr1[i].split('=')
        if (arr2[0] === key) {
            return decodeURI(arr2[1])
        }
    }
}
function _removeCookie(key) {
    setCookie(key, '', -365)
}
function _getQueryParams() {
    var url = location.search // 获取url中"?"符后的字串
    var theRequest = {}
    if (url.indexOf('?') !== -1) {
        var strs = url.substr(1)
        strs = strs.split('&')
        for (var i = 0; i < strs.length; i++) {
            //20200702 将unescape改成decodeURIComponent，否则参数是中文会报错
            theRequest[strs[i].split('=')[0]] = decodeURIComponent(strs[i].split('=')[1])
            // theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1]
        }
    }
    // console.log('theRequest',theRequest)
    return theRequest
}
function _formatCheckView(data, olderData) {
    let checkView = olderData
    data.forEach(obj => {
        switch (obj.mktype) {
        case '1': {
            checkView.limitedTime = {
                id: obj.id,
                status: true,
                mktype: 1, // 1限时优惠
                discounttype: obj.discounttype,
                discountvalue: obj.discountvalue,
                expirehours: obj.expirehours,
                datacond: obj.datacond
            }
            break
        }
        case '3': {
            checkView.assemble = {
                id: obj.id,
                status: true,
                mktype: 3, // 拼团减价
                discounttype: obj.discounttype,
                discountvalue: obj.discountvalue,
                expirehours: obj.expirehours,
                datacond: obj.datacond
            }
            break
        }
        case '5': {
            checkView.assistance = {
                id: obj.id,
                status: true,
                mktype: 5, // 助力减价
                discounttype: obj.discounttype,
                discountvalue: obj.discountvalue,
                expirehours: obj.expirehours,
                datacond: obj.datacond
            }
            break
        }
        case '6': {
            checkView.share = {
                id: obj.id,
                status: true,
                mktype: 6, // 6分享解锁
                discounttype: obj.discounttype,
                discountvalue: obj.discountvalue,
                expirehours: obj.expirehours,
                datacond: obj.datacond
            }
            break
        }
        }
    })
    return checkView
}
function _formatCheckList(data) {
    let tmpList = []
    for (let i in data) {
        if (data[i].status) {
            delete data[i].status
            tmpList.push(data[i])
        }
    }
    return tmpList
}
function _numberRound (num, length) {
    let len = length
    if (isNaN(num)) {
        return '不是数字'
    } else {
        const p1 = Math.pow(10, len + 1)
        const p2 = Math.pow(10, len)
        let number = (Math.round(num * p1 / 10) / p2).toFixed(len)
        return number
    }
}
function _urlToQRCode(url) {
    let base64 = ''
    let canvas = document.createElement('canvas')
    QRCode.toCanvas(canvas, url, (error) => {
        if (error) {
            base64 = url
        } else {
            base64 = canvas.toDataURL('image/png')
        }
    })
    return base64
}
function _promiseUrlToQRCode(url, logoUrl) {
    let image = new Image()
    image.setAttribute('crossOrigin', 'Anonymous') // 防止画图污染
    image.src = logoUrl
    // let qrcode = new Promise(function(resolve, reject) {
    let qrcode = new Promise(function(resolve) {
        image.onload = function() {
            let base64 = ''
            let canvas = document.createElement('canvas')
            canvas.width = 160
            canvas.height = 160
            let ctx = canvas.getContext('2d')
            ctx.fillStyle = '#fff'
            ctx.fillRect(0, 0, 160, 160)
            QRCode.toCanvas(canvas, url, (error) => {
                if (error) {
                    base64 = url
                } else {
                    base64 = canvas.toDataURL('image/png')
                }
            })
            ctx.fillStyle = '#fff' // logo padding颜色
            ctx.fillRect(75, 75, 60, 60) // logo 位置 大小
            ctx.drawImage(image, 80, 80, 50, 50) // logo
            ctx.restore()
            base64 = canvas.toDataURL('image/png')
            resolve(base64)
        }
    })
    return qrcode
}
function _data64toFile (dataurl, filename) {
    let arr = dataurl.split(',')
    let mime = arr[0].match(/:(.*?);/)[1]
    let bstr = atob(arr[1])
    let n = bstr.length
    let u8arr = new Uint8Array(n)
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], filename, {type: mime})
}
function _formatFileInfo(data) {
    let tmp = ''
    if (data.type === 'add') {
        delete data.type
        tmp = JSON.stringify(data)
    }
    return tmp
}
function _timestampFormat (date, fmt) {
    let time = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'S': date.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (var k in time) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (time[k]) : (('00' + time[k]).substr(('' + time[k]).length)))
        }
    }
    return fmt
}
function _computeFileSize(size) {
    let tmp = 0
    if (size < 1024) {
        tmp = _numberRound(size, 2) + 'B'
    } else if (size < 1024 * 1024) {
        tmp = _numberRound(size / 1024, 2) + 'KB'
    } else if (size < 1024 * 1024 * 1024) {
        tmp = _numberRound(size / 1024 / 1024, 2) + 'M'
    } else {
        tmp = _numberRound(size / 1024 / 1024 / 1024, 2) + 'G'
    }
    return tmp
}
function _downloadImage(imgsrc, name) { // 下载图片地址和图片名
    let image = new Image()
    // 解决跨域 Canvas 污染问题
    image.setAttribute('crossOrigin', 'anonymous')
    image.onload = function() {
        let canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        let context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        let url = canvas.toDataURL('image/png') // 得到图片的base64编码数据
        let a = document.createElement('a') // 生成一个a元素
        let event = new MouseEvent('click') // 创建一个单击事件
        a.download = name || 'photo' // 设置图片名称
        a.href = url // 将生成的URL设置为a.href属性
        a.dispatchEvent(event) // 触发a的单击事件
    }
    image.src = imgsrc
}
function _filetoData64(params) {
    let reader = new FileReader()
    reader.readAsDataURL(params.file)
    reader.onload = function (e) {
        params.success(e.target.result)
    }
}
function prefixInteger(num, n) {
    return (Array(n).join(0) + num).slice(-n);
}
function _datetime_fine_parse(time, format) {
    if(time==''){
        return ''
    }
    if (format === undefined) {
        format = 'm-d'
    }
    var YY = time.substring(0, 4)   //大年
    var yy = time.substring(2, 4)    //小年
    var mm = time.substring(4, 6)    //月
    var dd = time.substring(6, 8)       //日
    var HH = time.substring(8, 10)
    HH = HH !== '' ? HH : '00'      //大时
    var hh = time.substring(8, 10)
    hh = hh !== '' ? hh : '00'
    hh = hh > 12 ? hh - 12 : hh
    hh = prefixInteger(hh, 2)   //小时
    var ii = time.substring(10, 12)
    ii = ii !== '' ? ii : '00'     //分
    var ss = time.substring(12, 14)
    ss = ss !== '' ? ss : '00'     //秒
    var timestamp = new Date()
    timestamp.setFullYear(YY)
    timestamp.setMonth(mm - 1)
    timestamp.setDate(dd)
    timestamp.setHours(HH)
    timestamp.setMinutes(ii)
    timestamp.setSeconds(ss)
    timestamp.setMilliseconds(0)
    var nowtime = (new Date()).getTime()//获取现在的时间戳
    var today = new Date()
    today.setHours(0)
    today.setMinutes(0)
    today.setSeconds(0)
    today.setMilliseconds(0)
    var oneday = 1000 * 60 * 60 * 24
    var yesterday = new Date(today - oneday)
    var beforeyesterday = new Date(today - oneday * 2)
    var day = today.getTime() // 获取今天凌晨的时间戳
    var pday = yesterday.getTime() // 获取昨天凌晨的时间戳
    var qday = beforeyesterday.getTime() // 获取前天凌晨的时间戳
    var diff = nowtime - timestamp
    var date_str = format
    date_str = date_str.replace('Y', YY)
    date_str = date_str.replace('y', yy)
    date_str = date_str.replace('m', mm)
    date_str = date_str.replace('d', dd)
    date_str = date_str.replace('H', HH)
    date_str = date_str.replace('h', hh)
    date_str = date_str.replace('i', ii)
    date_str = date_str.replace('s', ss)
    if (timestamp < qday) {
        //判断前天以前
        return date_str
    } else if (timestamp < pday && timestamp >= qday) {
        //判断前天
        return "前天"
    } else if (timestamp < day && timestamp >= pday) {
        //判断昨天
        return "昨天"
    } else if (diff >= 3600000 && diff < 86400000) {
        //判断24小时以内
        return Math.floor(diff / 3600000) + '小时前'
    } else if (diff >= 60000 && diff < 3600000) {
        //判断1小时以内
        return Math.floor(diff / 60000) + '分钟前'
    } else if (diff >= 0 && diff < 60000) {
        //判断1分钟以内
        return '刚刚'
    } else {
        //判断未来
        return date_str
    }
}
function _getAssignKeyLocationSearch(key, value) {
    if (location.search) {
        let params = location.search ? location.search.split('?')[1].split('&') : ''
        let paramsKeyValue = {}
        params.forEach(item => {
            paramsKeyValue[item.split('=')[0]] = item.split('=')[1]
        })
        if (value && value.length) {
            if (value.indexOf(paramsKeyValue[key]) > -1) {
                return true
            } else {
                return false
            }
        } else {
            return paramsKeyValue[key]
        }
    } else {
        return ''
    }
}
// 把大于一万的整数转成以万为单位的数
function _changeTenThousand(number) {
    let numberStr = String(parseInt(number))
    if (numberStr.length >= 5) {
        let numberStrArr = numberStr.split('')
        numberStrArr.splice(numberStrArr.length - 4, 0, '.')
        let numberStrResult = String(Number(numberStrArr.join('')).toFixed(1))
        if (numberStrResult.slice(-1) == 0) {
            return parseInt(numberStrResult) + '万'
        } else {
            return numberStrResult + '万'
        }
    } else {
        return numberStr
    }
}
function _examineMobilePhoneType() {
    if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) { // iOS
        return 'iOS'
    } else if (navigator.userAgent.match(/android/i)) { // android
        return 'android'
    }
}
// 解密
function _decode(data, keystr) {
    // 不能有空格
    data = String(data).replace(/\s/g, '')
    keystr = keystr ? keystr : apiAesKey
    let key = CryptoJS.enc.Utf8.parse(keystr)
    let decrypt = CryptoJS.AES.decrypt(data, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
    return decrypt.toString(CryptoJS.enc.Utf8)
}